// 教育演示注册表：演示页是独立的 HTML 文件，放 public/ 目录下，这里登记入口即可。
export const demos = [
  { id: 'solar-system', name: '太阳系演示', description: '交互式太阳系天体运动模拟', icon: 'el-icon-sunny', url: '/solar-system.html' }
]
